import React, { useContext } from 'react'
import { Switch, Tooltip, FormControlLabel } from '@mui/material'
import { styled } from '@mui/material/styles'
import PropTypes from 'prop-types'
import { LoadingContext } from '../M_Utils'

export function MSwitchButton({ label, checked, onClick, onChange, color, labelColor, fontSize, required, disabled, defaultChecked, tooltipName }) {
    const ctx = useContext(LoadingContext)
    color = color || ctx.primaryColor || 'var(--color-black)'
    labelColor = labelColor || ctx.secondaryColor || 'var(--color-black)'

    const CustomSwitch = styled(Switch)(() => ({
        width: 40,
        height: 24,
        padding: 0,
        display: 'flex',
        '&:active': {
            '& .MuiSwitch-switchBase.Mui-checked': {
                transform: 'translateX(9px)',
            },
        },
        '& .MuiSwitch-switchBase': {
            padding: 2,
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: color,
                },
            },
        },
        '& .MuiSwitch-thumb': {
            width: 20,
            height: 20,
            borderRadius: '50%',
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            opacity: 1,
            backgroundColor: 'rgba(0,0,0,.25)',
        },
    }))

    return (
        <Tooltip title={tooltipName || ''}>
            <FormControlLabel
                sx={{
                    margin: !label ? '0px' : '5px 0px',
                    color: labelColor,
                    '& .MuiSvgIcon-root': { fontSize: fontSize },
                    '& .MuiFormControlLabel-label': { marginLeft: '8px' }
                }}
                control={<CustomSwitch
                    checked={checked}
                    onChange={onChange}
                    onClick={onClick}
                    disableRipple
                    required={required}
                    disabled={disabled}
                    defaultChecked={defaultChecked}
                />}
                label={label}
            />
        </Tooltip>
    )
}

MSwitchButton.propTypes = {
    label: PropTypes.string,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    onChange: PropTypes.func,
    color: PropTypes.string,
    labelColor: PropTypes.string,
    fontSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    tooltipName: PropTypes.string,
}
